import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import apiService from '../services/apiService';

const SettingsContext = createContext(null);

/* Fallback matches server/config/defaults.js so the calendar works even
   before the first API response arrives. */
export const DEFAULT_SETTINGS = {
  workingHours: { start: '08:30', end: '18:00' },
  slotDurationMinutes: 30,
  maxAppointmentsPerSlot: 1,
  activeWeekdays: [1, 2, 3, 4, 5, 6],
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loaded, setLoaded]     = useState(false);

  const reload = useCallback(() => {
    return apiService.fetchSettings()
      .then((s) => { setSettings(s); setLoaded(true); })
      .catch(() => setLoaded(true));
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return (
    <SettingsContext.Provider value={{ settings, loaded, reload }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
